import { buildProps } from '@vuesax-plus/utils'
import type { ExtractPropType } from '@vuesax-plus/utils'
import type { VuesaxColor } from './color'
import type { PropType } from 'vue'

export const baseProps = {
  color: {
    type: String as PropType<VuesaxColor | string>,
    default: null,
  },
  danger: {
    type: Boolean,
  },
  success: {
    type: Boolean,
  },
  warn: {
    type: Boolean,
  },
  dark: {
    type: Boolean,
  },
  primary: {
    type: Boolean,
  },
}
const _base = buildProps(baseProps)
export type BaseProps = ExtractPropType<typeof _base>
